import React from 'react';
import LogoSkull from './logo/LogoSkull';
import LogoWordmark from './logo/LogoWordmark';

// The colour logo is TWO inline SVGs (skull mark + wordmark) so the skull can
// animate on its own (see App.css) and both stay vector-crisp on 1x screens.
// Locally-served, pre-processed white-on-transparent PNG (see
// /app/backend/scripts/build_white_logo.py). Rebuild that script if the
// brand JPG ever changes.
const WHITE_LOGO = "/logo-white.png";

const Logo = ({ className = "", variant = "color" }) => {
  if (variant === "white") {
    return (
      <img
        src={WHITE_LOGO}
        alt="The TMD Physio - Krina Panchal"
        className={`logo-image ${className}`}
        width="1883"
        height="387"
        decoding="async"
        draggable={false}
      />
    );
  }

  return (
    <span
      className={`logo-image logo-image-svg ${className}`}
      aria-label="The TMD Physio - Krina Panchal"
      role="img"
    >
      <LogoSkull className="logo-image-skull" />
      <LogoWordmark className="logo-image-wordmark" />
    </span>
  );
};

export default Logo;
